namespace TR {
    class FiltersBox {

        aggregates: any;
        filters: any;
        enabledFilters: any;
        show: boolean;

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private filtering: any
        ) {
            $scope.$watch('fi.filters', f => this.updateFilters(f), true);
            this.enabledFilters = [];
        }

        updateFilters(filters) {
            if (!filters) { return; }
            const position = $('body').scrollTop();
            const listener = this.$scope.$on(
                '$locationChangeSuccess',
                () => {
                    $('body').scrollTop(position);
                    listener();
                });
            this.enabledFilters = Object.keys(filters);
            if (this.filtering.serialiseFilters(filters)) {
                return this.broker.publish('REFRESHSEARCH');
            }
        }

        showFilter(name) {
            return this.enabledFilters.indexOf(name) > -1;
        }

        apply() {
            return this.show = false;
        }
    }

    angular
        .module('TR')
        .directive('filtersBox', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: 'partials/home/directivetemplate?type=FiltersBox',
                bindToController: {
                    aggregates: '=',
                    filters: '=',
                    priceMode: '=',
                    show: '='
                },
                controller: FiltersBox,
                controllerAs: 'fi'
            };
        });

}
